import { normalizeError } from '@epihub/core/src/errors';
import { bindEmitterToWSClient } from '@epihub/core/src/events';
import { createUseWSSubscription } from '@epihub/web/src/events/ws/useWSSubscription';
import { getHTTPProtocol } from '@epihub/core/src/process/protocols';
import { getAppDomains } from '@krishanmadan/core/src/_ctx/vars';
import { useGlobalStore } from '../store/useGlobalStore';

export const wsClient = bindEmitterToWSClient({
  url: `${getHTTPProtocol()}//${getAppDomains().backend}`,
  path: '/ws',
  onError: (e) => normalizeError(e).log(),
  getCredentials: async () => {
    return {
      ['x-visitor-id']: useGlobalStore.getState().settings.visitorId,
    };
  },
});

setTimeout(() => wsClient.connect(), 2000);

export const useWSSubscription = createUseWSSubscription(wsClient);
